import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 20px;
  & > * {
    margin: 0 10px 10px 0;
  }
`;
